import server from "@/plugins/api";
import erudio from "@/plugins/erudio";
import { statusInscricao } from "../../status-inscricao";
import { format } from "date-fns";

const JUSTIFICATIVA_MOVIMENTACAO = "DEFERIDO NO CADASTRO DE VAGA INTEGRAL";

export const atualizar = async (inscricao) => {
  try {
    await server.put(`inscricao/${inscricao.id}`, inscricao);
    return { message: "Inscricão atualizada com sucesso", color: "success" };
  } catch (error) {
    console.error(error);
    return { message: error.message, color: "error" };
  }
};

export const deferir = async (inscricao, turmaDestino, enturmacaoAtual) => {
  const isMesmaUnidade =
    enturmacaoAtual.turma.unidadeEnsino.id === turmaDestino.unidadeEnsino.id;

  const resultado = isMesmaUnidade
    ? await movimentarTurma(inscricao, turmaDestino, enturmacaoAtual)
    : await transferir(inscricao, turmaDestino, enturmacaoAtual);

  if (resultado?.color === "error") {
    return resultado;
  }

  inscricao.turma_deferida = turmaDestino.id;
  inscricao.status = statusInscricao.DEFERIDO;
  return atualizar(inscricao);
};

export const desistir = (inscricao) => {
  inscricao.status = statusInscricao.DESISTENTE;
  return atualizar(inscricao);
};

export const indeferir = (inscricao) => {
  inscricao.status = statusInscricao.INDEFERIDO;
  return atualizar(inscricao);
};

export const retornarPendente = (inscricao) => {
  inscricao.status = statusInscricao.PENDENTE;
  return atualizar(inscricao);
};

export const transferir = async (inscricao, turmaDestino) => {
  try {
    await erudio.post("transferencias", {
      ignorarProtocoloFilaUnica: true,
      justificativa: JUSTIFICATIVA_MOVIMENTACAO,
      matricula: { id: inscricao.matricula.id },
      unidadeEnsinoDestino: { id: turmaDestino.unidadeEnsino.id },
      unidadeEnsinoOrigem: {
        id: inscricao.matricula.unidadeEnsino.id,
      },
    });
  } catch (error) {
    return {
      message: error.message,
      color: "error",
    };
  }

  // Mapeia dados no formato necessário para envio de e-mail
  const enturmacao = {
    matricula: {
      nomeAluno: inscricao.matricula.pessoa.nome,
      unidadeEnsino: {
        id: turmaDestino.unidadeEnsino.id,
        email: turmaDestino.unidadeEnsino.email,
        nomeCompleto: turmaDestino.unidadeEnsino.nomeCompleto,
      },
    },
    turma: {
      nomeCompleto: turmaDestino.nomeCompleto,
    },
  };

  enviaEmail({ enturmacao, inscricao });

  return {
    message: `${inscricao.matricula.pessoa.nome} transferido para ${turmaDestino.nomeCompleto}.`,
    color: "success",
  };
};

const movimentarTurma = async (inscricao, turmaDestino, enturmacaoOrigem) => {
  try {
    await erudio.post("movimentacoes-turma", {
      enturmacaoOrigem: { id: enturmacaoOrigem.id },
      justificativa: JUSTIFICATIVA_MOVIMENTACAO,
      matricula: { id: inscricao.matricula.id },
      turmaDestino: { id: turmaDestino.id },
      dataEfetivacao: format(new Date(), "yyyy-MM-dd"),
    });

    enviaEmail({ enturmacao: enturmacaoOrigem, inscricao });

    return {
      message: `${inscricao.matricula.pessoa.nome} enturmado na turma ${turmaDestino.nomeCompleto}`,
      color: "success",
    };
  } catch (error) {
    console.error(error);
    return {
      message: error.message,
      color: "error",
    };
  }
};

const enviaEmail = (conteudo) => {
  try {
    server.post("envia-email", conteudo);
  } catch (error) {
    return {
      message: "Erro ao enviar e-mail",
      color: "error",
    };
  }
};
